<p>product-stock-detail works!</p>
